export default "__VITE_ASSET__BV14hwMi__"